<template>
  <div id="details" class="fixed w-1/2 z-50 top-0 left-0 text-left pointer-events-none">
    <p>{{ project.title }}</p>
    </div>
</template>

<script>
export default {
  name: "Details",
  props: ['project']
}
</script>

<style>
#details > p {
  z-index:100;
  margin-block-start: 0px;
  margin-block-end: 0px;
  padding-left:10px;
  text-align:left;
  font-family:L;
  font-weight: bold;
  font-size:20px;
  color: #ffffff;
    overflow: hidden; 
    white-space:nowrap; 
    text-overflow: ellipsis;
}
</style>